module.exports = __webpack_public_path__ + "static/media/techLead2.17fd6c33.jpg";